import { Post } from '../helpers';

interface AddedFolderEntry {
  group_uuid: string;
  event_uuid: string;
}

export const AddProjectsToFolder = async ({
  channel,
  groupUuid,
  eventUuids,
}: {
  channel: number;
  groupUuid: string;
  eventUuids: string[];
}): Promise<AddedFolderEntry[]> => {
  const body = { groupUuid, eventUuids };
  return Post({
    path: `/v3/admin/channel/${channel}/event-groups/add-event-to-event-group`,
    body,
  });
};
